<div class="whats-new">
    <p class="whats-new__intro">
        Agentic development has accelerated the pace of change here. FlowStudio was first built in 2018 on Angular 4,
        and has survived four Microsoft API changes and three portal redesigns since then.
        Agents are now helping us with testing and grouping related changes into reviewable specifications &mdash;
        which means we can move faster and more safely than before.
        We took on a lot of upgrades at once, so please bear with us while we iterate through them.
    </p>

    <p class="whats-new__link">
        <a href="https://johnliu.net/blog/flow-studio-app-v14-major-update/" target="_blank" rel="noopener noreferrer">
            Read the full v14 release write-up &rarr;
        </a>
    </p>

    <ol class="whats-new__list">
        <li>
            <strong>Angular version update</strong>
        </li>
        <li>
            <strong>Switch to SWA</strong> (Azure Static Web Apps)
        </li>
        <li>
            <strong>Lightweight proxy <code>/api/</code></strong> &mdash; enables batching of multiple calls, making the browser more responsive
        </li>
        <li>
            <strong>Continued UX refresh</strong> &mdash; sorry if things look slightly inconsistent as we work through this. We aim to finish with a clean template using Tailwind and Fluent Design
        </li>
        <li>
            <strong>Caching library switching to SQLite in the browser</strong> (OPFS)
        </li>
        <li>
            <strong>Merging personal, admin and monitored flows</strong> into a unified view
        </li>
        <li>
            Please let us know via the <strong>Bug Report</strong> button if anything breaks your workflow!
        </li>
        <li>
            <strong>After this version stabilises</strong>, we will be adding a <em>lot</em> more tools &mdash; stay tuned.
        </li>
    </ol>
</div>
